import { render, staticRenderFns } from "./ReportsScheduled.vue?vue&type=template&id=2ecfbaa0"
import script from "./ReportsScheduled.vue?vue&type=script&lang=js"
export * from "./ReportsScheduled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports